import {
  CapaQuotationRecommendation,
  CapaQuotationDetailedServiceType,
  CapaQuotationDetailedMaterialType,
  CapaQuotationMaterial,
  CapaQuotationServiceType,
  CapaQuotationProductPurpose,
  CapaPcbServiceType,
  CapaRfqPcbMaterialSupplyMethodType,
  CapaRfqPcbAssemblyMethodType,
  CapaDesignServiceType,
  CapaQuotationPartnerImagePortfolioProduceStepType,
  ProjectPurchaseOrderManageStatusType,
  CapaPaymentMethodType,
  ProjectStatusType,
  QuotationPartnerRfqCurrentSituationType
} from '@generated/graphql';

export const requestEnumToString = (
  value?:
    | CapaQuotationDetailedServiceType
    | CapaQuotationDetailedMaterialType
    | CapaQuotationRecommendation
    | CapaQuotationMaterial
    | CapaQuotationServiceType
    | CapaQuotationProductPurpose
    | CapaQuotationPartnerImagePortfolioProduceStepType
    | string
) => {
  switch (value) {
    /* ServiceType */
    case CapaQuotationServiceType.MechanicalDesign:
      return '기구설계';
    case CapaQuotationServiceType.ProductDesign:
      return '제품 디자인';
    case CapaQuotationServiceType.Cnc:
      return 'CNC 가공';
    case CapaQuotationServiceType.Printing:
      return '3D 프린팅';
    case CapaQuotationServiceType.Inj:
      return '금형사출';
    case CapaQuotationServiceType.SheetMetal:
      return '판금가공';
    case CapaQuotationServiceType.Casting:
      return '주조';
    case CapaQuotationServiceType.Weilding:
      return '용접';
    case CapaQuotationServiceType.Bending:
      return '벤딩';
    case CapaQuotationServiceType.Prototyping:
      return '시제품 제작';
    case CapaQuotationServiceType.Design:
      return '디자인/설계';
    case CapaQuotationServiceType.Pcb:
      return '전자회로(PCB)';

    /* CapaDesignServiceType */
    case CapaDesignServiceType.MechanicalDesign:
      return '기구설계';
    case CapaDesignServiceType.ProductDesign:
      return '제품 디자인';

    /* CapaPcbServiceType */
    case CapaPcbServiceType.CircuitDesign:
      return '설계';
    case CapaPcbServiceType.CircuitFabrication:
      return '제작';
    case CapaPcbServiceType.CircuitAssembly:
      return '조립';

    /* CapaRfqPcbAssemblyMethodType */
    case CapaRfqPcbAssemblyMethodType.Smt:
      return 'SMT';
    case CapaRfqPcbAssemblyMethodType.Soldering:
      return '수땜';

    /* CapaRfqPcbMaterialSupplyMethodType */
    case CapaRfqPcbMaterialSupplyMethodType.CustomerSupply:
      return '사급';
    case CapaRfqPcbMaterialSupplyMethodType.PartialSelfSupply:
      return '부분도급';
    case CapaRfqPcbMaterialSupplyMethodType.SelfSupply:
      return '도급';

    /* DetailedServiceType */
    case CapaQuotationDetailedServiceType.Milling:
      return '밀링 (Milling)';
    case CapaQuotationDetailedServiceType.Turning:
      return '선반 (Turning)';
    case CapaQuotationDetailedServiceType.MachiningCenter:
      return '머시닝 센터 (Machining Center)';
    case CapaQuotationDetailedServiceType.Drilling:
      return '드릴링 (Drilling)';
    case CapaQuotationDetailedServiceType.Sla:
      return 'SLA';
    case CapaQuotationDetailedServiceType.Fdm:
      return 'FDM';
    case CapaQuotationDetailedServiceType.Polyjet:
      return 'Polyjet';
    case CapaQuotationDetailedServiceType.Mjf:
      return 'MJF';
    case CapaQuotationDetailedServiceType.Sls:
      return 'SLS';
    case CapaQuotationDetailedServiceType.SlmDmls:
      return 'SLM/DMLS';
    case CapaQuotationDetailedServiceType.InjectionMolding:
      return '일반 사출 (Injection Molding)';
    case CapaQuotationDetailedServiceType.DoubleShotInjectionMolding:
      return '이중 사출 (Double-Shot Injection Molding)';
    case CapaQuotationDetailedServiceType.BlowInjectionMolding:
      return '블로우 사출 (Blow Injection Molding)';
    case CapaQuotationDetailedServiceType.InsertInjectionMolding:
      return '인서트 사출 (Insert Injection Molding)';
    case CapaQuotationDetailedServiceType.Press:
      return '프레스 (Press)';
    case CapaQuotationDetailedServiceType.LaserCutting:
      return '레이저 커팅 (Laser Cutting)';
    case CapaQuotationDetailedServiceType.WaterjetCutting:
      return '워터젯 커팅 (Waterjet Cutting)';
    case CapaQuotationDetailedServiceType.SandCasting:
      return '사형 주조 (Sand Casting)';
    case CapaQuotationDetailedServiceType.ShellCasting:
      return '쉘 주조 (Shell Moulding)';
    case CapaQuotationDetailedServiceType.InvestmentCasting:
      return '인베스트먼트 주조 (Investment Casting)';
    case CapaQuotationDetailedServiceType.DieCasting:
      return '다이캐스팅 (Die Casting)';
    case CapaQuotationDetailedServiceType.CentrifugalCasting:
      return '원심 주조 (Centrifugal Casting)';
    case CapaQuotationDetailedServiceType.Recommend:
      return '파트너 추천이 필요합니다.';

    /* Material */
    case CapaQuotationMaterial.AbsIndustrial:
      return 'ABS(산업용)';
    case CapaQuotationMaterial.Aluminum:
      return '알루미늄 (Aluminum)';
    case CapaQuotationMaterial.AluminumAlloy:
      return '알루미늄 합금(Aluminum Alloy)';
    case CapaQuotationMaterial.Brass:
      return '황동 (Brass)';
    case CapaQuotationMaterial.Bronze:
      return '청동 (Bronze)';
    case CapaQuotationMaterial.CarbonSteel:
      return '탄소강 (Carbon Steel)';
    case CapaQuotationMaterial.Copper:
      return '구리 (Copper)';
    case CapaQuotationMaterial.CopperAlloy:
      return '구리 합금(Copper Alloy)';
    case CapaQuotationMaterial.GalvanizedSteel:
      return '아연 강 (Galvanized Steel)';
    case CapaQuotationMaterial.Iron:
      return '주철 (Iron)';
    case CapaQuotationMaterial.MagnesiumAlloy:
      return '마그네슘 합금 (Magnesium Alloy)';
    case CapaQuotationMaterial.MetalInj:
      return '금속 (Metal)';
    case CapaQuotationMaterial.Pa12:
      return 'PA12';
    case CapaQuotationMaterial.Pla:
      return 'PLA';
    case CapaQuotationMaterial.Plastic:
      return '플라스틱 (Plastic)';
    case CapaQuotationMaterial.ResinTranslucent:
      return '레진 (반투명)';
    case CapaQuotationMaterial.ResinTransparent:
      return '레진 (투명)';
    case CapaQuotationMaterial.ResinWhite:
      return '레진 (흰색)';
    case CapaQuotationMaterial.RubberLike:
      return '고무 유사';
    case CapaQuotationMaterial.StainlessSteel:
      return '스테인리스 강(Stainless Steel)';
    case CapaQuotationMaterial.Steel:
      return '강철(Steel)';
    case CapaQuotationMaterial.SteelCasting:
      return '주강 (Steel)';
    case CapaQuotationMaterial.SteelAlloy:
      return '합금강 (Steel Alloy)';
    case CapaQuotationMaterial.Vero:
      return 'Vero (멀티 컬러)';
    case CapaQuotationMaterial.ZincAlloy:
      return '아연 합금 (Zinc Alloy)';
    case CapaQuotationMaterial.Etc:
      return '기타(직접입력)';
    case CapaQuotationMaterial.Recommend:
      return '파트너 추천이 필요합니다';

    /* DetailedMaterialType */
    case CapaQuotationDetailedMaterialType.Abs:
      return 'ABS';
    case CapaQuotationDetailedMaterialType.Acryl:
      return '아크릴 (Acrylic)';
    case CapaQuotationDetailedMaterialType.McNylon:
      return 'MC Nylon';
    case CapaQuotationDetailedMaterialType.McNylon_66:
      return 'MC Nylon 66';
    case CapaQuotationDetailedMaterialType.Pc:
      return '폴리카보네이트(PC)';
    case CapaQuotationDetailedMaterialType.Pe:
      return '폴리에틸렌(PE)';
    case CapaQuotationDetailedMaterialType.Pp:
      return '폴리프로필렌(PP)';
    case CapaQuotationDetailedMaterialType.AcetalPom:
      return '아세탈(POM)';
    case CapaQuotationDetailedMaterialType.Peek:
      return 'PEEK';
    case CapaQuotationDetailedMaterialType.Bakelite:
      return '베이클라이트(Bakelite)';
    case CapaQuotationDetailedMaterialType.Teflon:
      return '테플론(PTFE)';
    case CapaQuotationDetailedMaterialType.Aluminum_2024T3:
      return '2024-T3';
    case CapaQuotationDetailedMaterialType.Aluminum_6061T6:
      return '6061-T6';
    case CapaQuotationDetailedMaterialType.Aluminum_6063:
      return '6063';
    case CapaQuotationDetailedMaterialType.Aluminum_7050:
      return '7050';
    case CapaQuotationDetailedMaterialType.Aluminum_7075T6:
      return '7075-T6';
    case CapaQuotationDetailedMaterialType.Aluminum_7075T7351:
      return '7075-T7351';
    case CapaQuotationDetailedMaterialType.AluminumMic_6:
      return 'MIC-6';
    case CapaQuotationDetailedMaterialType.Ss15_5:
      return 'SS 15-5';
    case CapaQuotationDetailedMaterialType.Ss17_4:
      return 'SS 17-4';
    case CapaQuotationDetailedMaterialType.Ss18_8:
      return 'SS 18-8';
    case CapaQuotationDetailedMaterialType.Ss303:
      return 'SS 303';
    case CapaQuotationDetailedMaterialType.Ss304:
      return 'SS 304';
    case CapaQuotationDetailedMaterialType.Ss316Ss316L:
      return 'SS 316/316L';
    case CapaQuotationDetailedMaterialType.Ss416:
      return 'SS 416';
    case CapaQuotationDetailedMaterialType.Ss420:
      return 'SS 420';
    case CapaQuotationDetailedMaterialType.Ss235Ss330:
      return 'SS235(SS330)';
    case CapaQuotationDetailedMaterialType.Ss275Ss400:
      return 'SS275(SS400)';
    case CapaQuotationDetailedMaterialType.Ss315Ss490:
      return 'SS315(SS490)';
    case CapaQuotationDetailedMaterialType.Ss410Ss540:
      return 'SS410(SS540)';
    case CapaQuotationDetailedMaterialType.Ss450Ss590:
      return 'SS450(SS590)';
    case CapaQuotationDetailedMaterialType.Ss550:
      return 'SS550';
    case CapaQuotationDetailedMaterialType.Copper_101:
      return 'Copper 101';
    case CapaQuotationDetailedMaterialType.Copper_260Brass:
      return 'Copper 260(Brass)';
    case CapaQuotationDetailedMaterialType.CopperC110:
      return 'Copper C110';
    case CapaQuotationDetailedMaterialType.CopperC360Brass:
      return 'Copper C360(Brass)';
    case CapaQuotationDetailedMaterialType.CopperC932Bronze:
      return 'Copper C932(Bronze)';
    case CapaQuotationDetailedMaterialType.S10CSm10C:
      return 'S10C(SM10C)';
    case CapaQuotationDetailedMaterialType.S15CSm15C:
      return 'S15C(SM15C)';
    case CapaQuotationDetailedMaterialType.S20CSm20C:
      return 'S20C(SM20C)';
    case CapaQuotationDetailedMaterialType.S25CSm25C:
      return 'S25C(SM25C)';
    case CapaQuotationDetailedMaterialType.S30CSm30C:
      return 'S30C(SM30C)';
    case CapaQuotationDetailedMaterialType.S35CSm35C:
      return 'S35C(SM35C)';
    case CapaQuotationDetailedMaterialType.S40CSm40C:
      return 'S40C(SM40C)';
    case CapaQuotationDetailedMaterialType.S45CSm45C:
      return 'S45C(SM45C)';
    case CapaQuotationDetailedMaterialType.S50CSm50C:
      return 'S50C(SM50C)';
    case CapaQuotationDetailedMaterialType.S55CSm55C:
      return 'S55C(SM55C)';
    case CapaQuotationDetailedMaterialType.GeneralBrass:
      return '황동(Brass)';
    case CapaQuotationDetailedMaterialType.GeneralBronze:
      return '청동';
    case CapaQuotationDetailedMaterialType.Scm_415:
      return 'SCM415';
    case CapaQuotationDetailedMaterialType.Scm_420:
      return 'SCM420';
    case CapaQuotationDetailedMaterialType.Scm_440:
      return 'SCM440';
    case CapaQuotationDetailedMaterialType.Asa:
      return 'ASA';
    case CapaQuotationDetailedMaterialType.Hdpe:
      return 'HDPE';
    case CapaQuotationDetailedMaterialType.NylonPa:
      return 'Nylon(PA)';
    case CapaQuotationDetailedMaterialType.Pbt:
      return 'PBT';
    case CapaQuotationDetailedMaterialType.Pct:
      return '트라이탄 (PCT)';
    case CapaQuotationDetailedMaterialType.Pei:
      return 'PEI';
    case CapaQuotationDetailedMaterialType.Pet:
      return 'PET';
    case CapaQuotationDetailedMaterialType.Pmma:
      return 'PMMA';
    case CapaQuotationDetailedMaterialType.Ps:
      return 'PS';
    case CapaQuotationDetailedMaterialType.Pvc:
      return 'PVC';
    case CapaQuotationDetailedMaterialType.Tpe:
      return 'TPE';
    case CapaQuotationDetailedMaterialType.Tpu:
      return 'TPU';
    case CapaQuotationDetailedMaterialType.AluminumAlloy:
      return '알루미늄 합금';
    case CapaQuotationDetailedMaterialType.ZincAlloy:
      return '아연 합금';
    case CapaQuotationDetailedMaterialType.MagnesiumAlloy:
      return '마그네슘 합금';
    case CapaQuotationDetailedMaterialType.Ldpe:
      return 'LDPE';
    case CapaQuotationDetailedMaterialType.Recommend:
      return '기타 재료 (직접 입력)';

    /* recommendation */
    case CapaQuotationRecommendation.Strength:
      return '강도가 중요해요';
    case CapaQuotationRecommendation.ThermalStrain:
      return '열 변형이 적어야해요';
    case CapaQuotationRecommendation.CorrosionResistant:
      return '내부식성이 중요해요';
    case CapaQuotationRecommendation.Light:
      return '가벼워야해요';
    case CapaQuotationRecommendation.SurfaceQuality:
      return '표면 품질이 중요해요';
    case CapaQuotationRecommendation.ShockResistance:
      return '내충격성이 중요해요';
    case CapaQuotationRecommendation.Allowance:
      return '공차가 중요해요';
    case CapaQuotationRecommendation.Flexibility:
      return '유연성이 중요해요';
    case CapaQuotationRecommendation.Elasticity:
      return '탄성이 높아야해요';
    case CapaQuotationRecommendation.DecideAfterConsulting:
      return '상담 후 결정할게요';
    case CapaQuotationRecommendation.Etc:
      return '기타';

    case CapaQuotationProductPurpose.AutomobileTransportation:
      return '자동차 / 운송';
    case CapaQuotationProductPurpose.ManufacturinEquipmentIndustrialMachineAndParts:
      return '생산 설비 / 장비 및 부속품';
    case CapaQuotationProductPurpose.RoboticsDroneIotSmartDevice:
      return '로봇 / 드론 / IOT / 스마트기기';
    case CapaQuotationProductPurpose.MedicalHealthcare:
      return '의료 / 건강';
    case CapaQuotationProductPurpose.SemiconductorElectronicBoards:
      return '반도체 / 기관';
    case CapaQuotationProductPurpose.OpticsMaterials:
      return '광학 / 신소재';
    case CapaQuotationProductPurpose.HouseholdAppliance:
      return '가전';
    case CapaQuotationProductPurpose.ExperimentInspectionDiagnosisMeasuring:
      return '검사 / 시험 / 진단 / 측정 장비';
    case CapaQuotationProductPurpose.EnergyBatteries:
      return '에너지 / 배터리';
    case CapaQuotationProductPurpose.BroadcastCommunicationMultimedia:
      return '방송 / 통신 / 멀티미디어';
    case CapaQuotationProductPurpose.ResearchAndDevelopment:
      return '연구개발';
    case CapaQuotationProductPurpose.Aerospace:
      return '항공 / 우주';
    case CapaQuotationProductPurpose.MilitarySafety:
      return '국방 / 안전';
    case CapaQuotationProductPurpose.OceanIndustryShipbuilding:
      return '해양 / 선박';
    case CapaQuotationProductPurpose.AgricultureFarming:
      return '농업';
    case CapaQuotationProductPurpose.GadgetsPartsComponents:
      return '주변기기 / 부속 부품';
    case CapaQuotationProductPurpose.KitchenFood:
      return '주방 / 식품';
    case CapaQuotationProductPurpose.EducationToys:
      return '교육 / 완구';
    case CapaQuotationProductPurpose.SportsOutdoors:
      return '스포츠 / 아웃도어';
    case CapaQuotationProductPurpose.FashionBeauty:
      return '패션 / 뷰티';
    case CapaQuotationProductPurpose.InteriorLiving:
      return '인테리어 / 리빙';
    case CapaQuotationProductPurpose.Furniture:
      return '가구';
    case CapaQuotationProductPurpose.Pets:
      return '반려동물';
    case CapaQuotationProductPurpose.PropsOfficeSupplies:
      return '생활소품 / 사무용품';
    case CapaQuotationProductPurpose.ArtsExhibition:
      return '예술 / 전시';
    case CapaQuotationProductPurpose.ArchitectureConstruction:
      return '건축 / 공사';
    case CapaQuotationProductPurpose.PersonalHobby:
      return '개인 / 취미';
    case CapaQuotationProductPurpose.Etc:
      return '기타(직접 입력)';

    case CapaQuotationPartnerImagePortfolioProduceStepType.Prototyping:
      return '시제품 제작';
    case CapaQuotationPartnerImagePortfolioProduceStepType.SmallProduction:
      return '소량 생산';
    case CapaQuotationPartnerImagePortfolioProduceStepType.MassProduction:
      return '대량 생산';

    default:
      return value ?? '기타';
  }
};

export const projectPurchaseOrderManageStatusEnumToString = (
  type: ProjectPurchaseOrderManageStatusType
) => {
  switch (type) {
    case ProjectPurchaseOrderManageStatusType.All: {
      return '전체';
    }
    case ProjectPurchaseOrderManageStatusType.ConfirmPurchaseOrder: {
      return '거래완료';
    }
    case ProjectPurchaseOrderManageStatusType.OrderInprogress: {
      return '결제/발주중';
    }
    case ProjectPurchaseOrderManageStatusType.OrderSuspended: {
      return '결제/발주중단';
    }
    case ProjectPurchaseOrderManageStatusType.ProcessInterruption: {
      return '제조중단';
    }
    case ProjectPurchaseOrderManageStatusType.Processing: {
      return '제조중';
    }
    case ProjectPurchaseOrderManageStatusType.Shipping: {
      return '배송중';
    }
  }
};

export const paymentMethodEnumToString = (type: CapaPaymentMethodType) => {
  switch (type) {
    case CapaPaymentMethodType.CreditCard: {
      return '신용카드';
    }
    case CapaPaymentMethodType.VirtualAccount: {
      return '무통장입금';
    }
  }
};

export const projectStatusToString = (status: ProjectStatusType) => {
  switch (status) {
    case ProjectStatusType.All:
      return '전체';
    case ProjectStatusType.ConfirmPurchaseOrder:
      return '거래완료';
    case ProjectStatusType.OrderInprogress:
      return '결제/발주중';
    case ProjectStatusType.OrderSuspended:
      return '결제/발주중단';
    case ProjectStatusType.ProcessInterruption:
      return '제조중단';
    case ProjectStatusType.Processing:
      return '제조중';
    case ProjectStatusType.QuotationComparison:
      return '견적비교중';
    case ProjectStatusType.QuotationComparisonClosing:
      return '견적비교 마감';
    case ProjectStatusType.Shipping:
      return '배송중';
  }
};

export const quotationPartnerRfqCurrentSituationTypeToString = (
  situation: QuotationPartnerRfqCurrentSituationType
) => {
  switch (situation) {
    case QuotationPartnerRfqCurrentSituationType.All:
      return '전체';
    case QuotationPartnerRfqCurrentSituationType.ConfirmPurchaseOrder:
      return '거래완료';
    case QuotationPartnerRfqCurrentSituationType.ConsultingWithMe:
      return '나와 상담중';
    case QuotationPartnerRfqCurrentSituationType.ConsultingWithOtherCompany:
      return '타업체 상담중';
    case QuotationPartnerRfqCurrentSituationType.OrderInprogress:
      return '결제/발주중';
    case QuotationPartnerRfqCurrentSituationType.OrderSuspended:
      return '결제/발주중단';
    case QuotationPartnerRfqCurrentSituationType.OtherCompanyOrder:
      return '타업체 발주';
    case QuotationPartnerRfqCurrentSituationType.ProcessInterruption:
      return '제조중단';
    case QuotationPartnerRfqCurrentSituationType.Processing:
      return '제조중';
    case QuotationPartnerRfqCurrentSituationType.RequestFinish:
      return '요청마감';
    case QuotationPartnerRfqCurrentSituationType.SendCompanyIntroduction:
      return '회사소개서 보냄';
    case QuotationPartnerRfqCurrentSituationType.SendQuotation:
      return '견적서 발행함';
    case QuotationPartnerRfqCurrentSituationType.Shipping:
      return '배송중';
  }
};
